export interface Testimonial {
  quote: string
  name: string
  location: string
}

export const topTestimonials: Testimonial[] = [
  {
    quote:
      'Je passais énormément de temps à préparer mes supports et à structurer mes séances. Maintenant, je sélectionne les ressources pertinentes, je les adapte à mon patient et je peux avancer beaucoup plus rapidement.',
    name: 'Sophie M.',
    location: 'Lyon, France',
  },
  {
    quote:
      'Ce que j’apprécie le plus, c’est la cohérence entre les objectifs, les activités et le suivi. Je ne cherche plus mes ressources dans plusieurs dossiers différents.',
    name: 'Claire D.',
    location: 'Paris, France',
  },
  {
    quote:
      'J’avais déjà mes méthodes et mon expérience, mais mes outils étaient dispersés. Ce système m’aide surtout à organiser beaucoup plus efficacement mon travail clinique.',
    name: 'Émilie R.',
    location: 'Bordeaux, France',
  },
]

export const testimonials: Testimonial[] = [
  {
    quote:
      'Je préparais souvent ma semaine en dehors de mes heures de consultation. Maintenant, j’ai une base organisée que je peux sélectionner et adapter beaucoup plus rapidement.',
    name: 'Julie M.',
    location: 'Paris, France',
  },
  {
    quote:
      'La bibliothèque d’activités m’apporte surtout de la structure. Je peux partir d’un objectif précis et identifier plus facilement les ressources pertinentes.',
    name: 'Camille B.',
    location: 'Lille, France',
  },
  {
    quote:
      'Les outils de progression sont particulièrement utiles. Je peux mieux relier ce que j’observe en séance aux adaptations que je veux mettre en place ensuite.',
    name: 'Laura C.',
    location: 'Lyon, France',
  },
  {
    quote:
      'Je travaille avec des profils très différents. Avoir plusieurs niveaux et possibilités d’adaptation facilite énormément l’organisation de mes séances.',
    name: 'Manon R.',
    location: 'Toulouse, France',
  },
  {
    quote:
      'Au fil des années, j’avais accumulé énormément de supports, de fiches et de notes. Avoir une structure centralisée rend mon organisation beaucoup plus simple.',
    name: 'Élodie W.',
    location: 'Bordeaux, France',
  },
  {
    quote:
      'Le système de préparation des séances est extrêmement pratique. Il réduit mon temps d’organisation tout en me laissant entièrement libre d’adapter chaque ressource.',
    name: 'Sarah D.',
    location: 'Nantes, France',
  },
]
